module.exports = __webpack_public_path__ + "img/loginlogo2.18f87953.png";